import { TrialProBadgeWithTooltip } from "@clockwise/web-commons/src/ui/trial-pro-badge-with-tooltip";
import { stringToCWId } from "@clockwise/web-commons/src/util/cw-id.util";
import { ListItemIcon, ListItemText, MenuItem, SvgIcon } from "@material-ui/core";
import * as React from "react";
import { CWID_PREFIX } from "./constants";

export interface IProps {
  label: string | React.ReactNode;
  onClick: () => void;
  IconComponent: typeof SvgIcon;
  hide?: boolean;
  showProBadge?: boolean;
}

export const ChromeMenuItem = ({
  label,
  onClick,
  IconComponent,
  hide = false,
  showProBadge,
}: IProps) => {
  if (hide) {
    return null;
  }
  return (
    <MenuItem
      classes={{ root: "cw-min-h-12" }}
      onClick={onClick}
      cw-id={stringToCWId(JSON.stringify(label), CWID_PREFIX)}
      aria-label={typeof label === "string" ? label : undefined}
    >
      <ListItemIcon>
        <IconComponent className="cw-text-muted" />
      </ListItemIcon>
      <ListItemText classes={{ root: "cw-flex-none cw-mr-2" }} inset primary={label} />
      {showProBadge ? <TrialProBadgeWithTooltip showToolTip={false} /> : null}
    </MenuItem>
  );
};
